import { Teaser as t } from '@xprog/prensa/types'
import { TeaserRelated } from './TeaserRelated'

export const TeaserImageLeft: t.TeaserProps = {
  css: {
    padding: '$0',
    mb: '$4',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      width: 'auto',
      'img': {
        pr: '$3'
      },
      '@lg': {
        maxWidth: '150px'
      }
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '18px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      lineHeight: '23px',
      width: '100%'
    },
    '.TeaserWrap': {
      ml: '$3',
      width: 'calc(100% - 88px - $3)'
    },
    '@media (max-width: 767px)': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      width: '100%',
      textAlign: 'center',
      '.TeaserImageContainer': {
        backgroundColor: 'transparent',
        width: 'auto',
        'img': {
          pr: '$3'
        },
        '@lg': {
          maxWidth: '150px'
        }
      },
      '.TeaserSubjectText': {
        alignItems: 'center',
        align: ['column', 'center', 'top'],
        textTransform: 'uppercase',
        fontSize: '14px'
      },
      '.TeaserSubtitleText': {
        display: 'none'
      },
      '.TeaserSubtitle': {
        align: ['row', 'left', 'middle'],
      },
      '.TeaserTitle': {
        my: '$2',
      },
      '.TeaserTitleText': {
        align: ['column', 'left', 'top'],
        color: 'black',
        fontSize: '26px',
        fontWeight: 400,
        letterSpacing: '0.2px',
        lineHeight: '23px',
        width: '100%'
      },
      '.TeaserWrap': {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '0px !important',
        width: '100%',
        '.TeaserRelated': {
          'div.Teaser': {
            mb: '$4',
          },
          'div.TeaserTitle': {
            'p.TeaserTitleText': {
              fontSize: '16px',
              lineHeight: '19px',
              letterSpacing: '0.2px'
            },
          },
        },
      }
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md',
  relatedLayout: TeaserRelated
}
